import React from 'react';
import {
    Table,
    Statistic
} from 'antd';

const columns = [
    {
        title: 'สินค้า',
        dataIndex: 'product',
        key: 'product',
        render: (_, columns) => `${columns.product?.name}:${columns.product.brand?.name} ${columns.product?.description ?? ""}`
    },
    {
        title: 'ราคา',
        dataIndex: 'price',
        key: 'price',
        render: (text, _) => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
    },
    {
        title: 'จำนวน',
        dataIndex: 'quantity',
        key: 'quantity',
    },
    {
        title: 'ส่วนลดต่อชิ้น',
        dataIndex: 'discount',
        key: 'discount',
        render: (_, option) => <Statistic value={(option.discount / option.quantity).toFixed(2)} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
    },
    {
        title: 'ส่วนลดรวม',
        dataIndex: 'discount',
        key: 'discount',
        render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
    },
    {
        title: 'รวม',
        dataIndex: 'total_price',
        key: 'total_price',
        render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14, textAlign: 'right' }} />
    },
];
function OrderItems({ items }) {
    // console.log('orderItems = ', items)
    return (
        <div>
            <Table
                rowKey={(record) => record.id}
                columns={columns}
                dataSource={items}
                pagination={false}
                scroll={{
                    x: 1200,
                }}
            />
        </div>
    )
}

export default OrderItems